// Codrops article: https://tympanus.net/codrops/2019/10/14/how-to-create-an-interactive-3d-character-with-three-js/
// Originally by Kyle Wetton @KyleWetton
// Brought to React by https://github.com/RubLo
// https://spectrum.chat/react-three-fiber/general/skinned-mesh~de461f24-df23-43d0-8e08-dca7fe3b93f7

import ReactDOM from "react-dom"
import React, { useState } from "react"
import { Canvas } from "react-three-fiber"
import Mask from "./Mask"
import "./styles.css"

import { useSpring } from 'react-spring/three'
import { Html } from "@react-three/drei"

function App() {

  const urlParams = new URLSearchParams(window.location.search);
  const theme = urlParams.get('theme') ?? 'christmas';

  const [hovered, setHover] = useState(false);
  const [selectedTexture, setSelectedTexture] = useState(theme === 'christmas' ? 'hoho' : 'monster');

  const { rotation } = useSpring({
    rotation: hovered ? [0, -2.8, 0] : [0, -0.4, 0]
  });


  return (
    <div>
      <Canvas
        pixelRatio={window.devicePixelRatio}
        camera={{ position: [0, -3, 18], fov: 20 }}
        onPointerOver={(e) => setHover(true)}
        onPointerOut={(e) => setHover(false)} 
        >
          <ambientLight intensity={0.8}/>
          <pointLight position={[40, 40, 40]} intensity={0.55} />
          <Html position={[0.5,2.2,0]}>
            <div className="hoverable">
              <svg width="19" height="50" viewBox="0 0 19 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.0196 0.494287C4.35016 -0.398346 3.33683 3.85317 5.43155 5.59242C7.52626 7.33168 14.0675 10.7826 16.0564 11.1783C18.0452 11.5832 19.4442 8.45437 17.8032 6.92677C16.1623 5.39917 9.68148 1.37772 7.0196 0.494287Z" fill={theme === 'christmas' ? "#00B28F" : "black"}/>
                <path d="M2.56561 28.7918C-1.12472 28.8746 -0.534874 23.2059 2.43706 22.4237C5.40898 21.6415 11.9124 21.6415 13.9542 21.5035C15.996 21.3654 18.2193 23.3256 15.7691 25.4881C13.3114 27.6599 5.25774 28.7366 2.56561 28.7918Z" fill={theme === 'christmas' ? "#C82127" : "#eb7809"}/>
                <path d="M15.096 37.2487C11.088 38.2793 6.87592 43.267 5.81721 45.8805C4.87951 48.1995 5.89283 50.6934 8.06317 49.5707C10.2335 48.448 15.2548 43.221 17.0697 41.537C18.8846 39.853 17.7276 36.5769 15.096 37.2487Z" fill={theme === 'christmas' ? "#00B28F" : "black"}/>
              </svg>
              <div>
                <h2>REVERSABLE</h2>
                <p>Hover over to see!</p>
              </div>
              <svg width="19" height="50" viewBox="0 0 19 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5063 49.3543C14.1758 50.2469 15.1891 45.9954 13.0944 44.2561C10.9997 42.5168 4.45841 39.0659 2.46956 38.6702C0.480715 38.2653 -0.918282 41.3941 0.722706 42.9217C2.36369 44.4494 8.84447 48.4708 11.5063 49.3543Z" fill={theme === 'christmas' ? "#00B28F" : "black"}/>
                <path d="M15.9604 21.0568C19.6508 20.974 19.0609 26.6427 16.089 27.4249C13.1171 28.2071 6.61361 28.2071 4.57183 28.3451C2.53004 28.4831 0.306773 26.523 2.75691 24.3605C5.21462 22.1887 13.2683 21.1212 15.9604 21.0568Z" fill={theme === 'christmas' ? "#C82127" : "#eb7809"}/>
                <path d="M3.42987 12.5997C7.43779 11.569 11.6499 6.5813 12.7086 3.96782C13.6463 1.64881 12.633 -0.845046 10.4626 0.277648C8.2923 1.40034 3.27105 6.62731 1.45614 8.31136C-0.35877 9.9954 0.798247 13.2807 3.42987 12.5997Z" fill={theme === 'christmas' ? "#00B28F" : "black"}/>
              </svg>
            </div>
          </Html>
          <Mask 
            position={[-0.3, -2.5, 0]}
            scale={[3, 3, 3]}
            rotation={rotation}
            selected={selectedTexture}/>
      </Canvas>
      <div className="bottom-container">
        <div className="button-container">
          { theme === 'christmas' ? <>
            <div className="mask-button" onClick={() => setSelectedTexture('hoho')} style={{backgroundImage: "url('/hoho.png')", opacity: selectedTexture === 'hoho' ? 1 : 0.6}}></div>
            <div className="mask-button" onClick={() => setSelectedTexture('holly')} style={{backgroundImage: "url('/holly.png')", opacity: selectedTexture === 'holly' ? 1 : 0.6 }}></div>
            <div className="mask-button" onClick={() => setSelectedTexture('merry')} style={{backgroundImage: "url('/merry.png')", opacity: selectedTexture === 'merry' ? 1 : 0.6 }}></div>
          </> : <>
            <div className="mask-button" onClick={() => setSelectedTexture('monster')} style={{backgroundImage: "url('/monster.png')", opacity: selectedTexture === 'monster' ? 1 : 0.6}}></div>
            <div className="mask-button" onClick={() => setSelectedTexture('clown')} style={{backgroundImage: "url('/clown.png')", opacity: selectedTexture === 'clown' ? 1 : 0.6 }}></div>
            <div className="mask-button" onClick={() => setSelectedTexture('pumpkin')} style={{backgroundImage: "url('/pumpkin.png')", opacity: selectedTexture === 'pumpkin' ? 1 : 0.6 }}></div>
          </>
          }
        </div>
        <p style={{ width: 200 }}>For illustration purposes only, see product images below for accurate representation.</p>
      </div>
    </div>
  )
}

ReactDOM.render(<App />, document.getElementById("root"))
